import { TextField, TextFieldProps } from "@mui/material";
import "./styles.css";

function TextInput(props: TextFieldProps) {
  return (
    <TextField
      // sx={{ bgcolor: "var(--color-overlay)" }}
      variant="outlined"
      {...props}
    />
  );
}

export default TextInput;
